import { Grid, Typography } from "@mui/material";
import styles from "../Information.module.scss";
import GridTableComponent from "../../common/GridTableComponent/gridTableTemplate";

const PaidSevas = () => {
  const AbhisekhaItem = [
    {
      ItemsNames: "Milk",
      Quantity: "1 Gallon",
    },
    {
      ItemsNames: "Honey",
      Quantity: "1 small bottle",
    },
    {
      ItemsNames: "Coconut",
      Quantity: "1",
    },
    {
      ItemsNames: "Rose Water",
      Quantity: "1 bottle",
    },
    {
      ItemsNames: "Flowers",
      Quantity: "some",
    },
    
    {
      ItemsNames: "Cooked Prasada",
      Quantity: "some",
    },
  ];
  const AbhisekhaItemAnother = [
    {
      ItemsNames: "Butter Milk",
      Quantity: "1½ Gallon ",
    },
    {
      ItemsNames: "Orange Juice",
      Quantity: "1½ Gallon ",
    },
    {
      ItemsNames: "Saffron",
      Quantity: "2 grams",
    },
    {
      ItemsNames: "Fruits",
      Quantity: "some",
    },
    {
      ItemsNames: "Almonds",
      Quantity: "some",
    },
  ];

  const KalanostavamItems = [
    {
      ItemsNames: "Rice",
      Quantity: "5 Lb",
    },
    {
      ItemsNames: "Akshatha (Yellow rice)",
      Quantity: "1½ Lb ",
    },
    {
      ItemsNames: "Coconut",
      Quantity: "5",
    },
    {
      ItemsNames: "Fruits",
      Quantity: "20",
    },
    {
      ItemsNames: "Milk",
      Quantity: "1½ Gallon ",
    },
    {
        ItemsNames: "Blouse Pieces",
        Quantity: "5",
      },
      {
        ItemsNames: "Cashews",
        Quantity: "1 Lb",
      },
      {
        ItemsNames: "Almonds",
        Quantity: "1 Lb",
      },
      {
        ItemsNames: "Raisins",
        Quantity: "1 Lb",
      },
      {
        ItemsNames: "Ghee",
        Quantity: "3 Lb",
      },
  ];

  const KalanostavamItemsOthers = [
    {
      ItemsNames: "Betal Leaves",
      Quantity: "25",
    },
    {
      ItemsNames: "Betel Nuts powder",
      Quantity: "1 Packet",
    },
    {
      ItemsNames: "Haldi",
      Quantity: "50 grams",
    },
    {
      ItemsNames: "kumkum",
      Quantity: "50 grams",
    },
    {
      ItemsNames: "Puffed Rice",
      Quantity: "200 grams",
    },
    {
        ItemsNames: "Camphor",
        Quantity: "1 Packet",
      },
      {
        ItemsNames: "Agarbhathi",
        Quantity: "1 Packet",
      },
      {
        ItemsNames: "Sarees (Optional)",
        Quantity: "3",
      },
      {
        ItemsNames: "Firewood (Kindling wood)",
        Quantity: "1 Packet",
      },
      {
        ItemsNames: "Cooked prasada",
        Quantity: "some",
      },
  ];
  const columnMapping = {
    ItemsNames: "Items Names",
    Quantity: "Quantity",
  };

  const AnnuualAbhisekaItems = [
    {
      number: "1",
      description: "Abhisheka to Lord Venkateswara (Vishnu/Balaji) ",
    },
    {
      number: "2",
      description: "Abhisheka to Lord Shiva (Daily)",
    },
    {
      number: "3",
      description: "Abhisheka to Lord Ganesha (Ganapathi) ",
    },
    {
      number: "4",
      description: "Abhisheka to Lord Karthikeya (Subramanya) ",
    },
    {
      number: "5",
      description: "Abhisheka to Lords Navagraha  ",
    },
    {
      number: "6",
      description: "Abhisheka to Lord Rama ",
    },
    {
      number: "7",
      description: "Abhisheka to Lord Anjaneya ",
    },
    {
      number: "8",
      description: "Abhisheka to Goddess Parvathi ",
    },
    {
      number: "9",
      description: "Abhisheka to Goddess Mahalakshmi ",
    },
    {
      number: "10",
      description: "Abhisheka to Goddess Boodevi ",
    },
    {
      number: "11",
      description: "Abhisheka to Goddess Kanaka Durga",
    },
    {
      number: "12",
      description: "Abhisheka to Goddess Dasabuja Durga in Temple",
    },
    {
      number: "13",
      description: "Abhisheka to Lord Narasimha",
    },
    {
      number: "14",
      description: "Abhisheka to Garuda, Nagaraja and Dwara Ganapathi  ",
    },
  ];
  const AnnuualAbhisekaItemsAndServiceProgram = [
    {
      number: "1",
      description: "Temple anniversary",
    },
    {
      number: "2",
      description: "Hanuman Jayanthi",
    },
    {
      number: "3",
      description: "Makara Sankranthi",
    },
    {
      number: "4",
      description: "Maha Shiva Rathri - Shiva Brahmostavam",
    },
    {
      number: "5",
      description: "Telugu, Kanada, Marati,Tamil New year - Ugadi Asthanam",
    },
    {
      number: "6",
      description: "Sri Rama Navami - Sita Rama Kalyanam",
    },
    {
      number: "7",
      description: "Narasimha Jayanthi",
    },
    {
      number: "8",
      description: "Hanuman Jayanti(II)",
    },
    {
      number: "9",
      description: "Jyeshta Abhisheka For Balaji",
    },
    {
      number: "10",
      description: "Pavitrostavam",
    },
    {
      number: "11",
      description: "Varalakshmi Vratham",
    },
    {
      number: "12",
      description: "Audi Poornam - Andal Neerattam",
    },
    {
      number: "13",
      description: "Raksha Bandhan, Sravana Upakarma (Rig, Yajur)",
    },
    {
      number: "14",
      description: "Srikrishna Janmastami Gokulastami",
    },
    {
      number: "15",
      description: "	Swarana Gouri Vratam",
    },
    {
      number: "16",
      description: "	Ganesha Chathurthi, Sama Veda Upakarma",
    },
    {
      number: "17",
      description: "Ganesha Visarjana",
    },
    {
      number: "18",
      description: "Navarathri",
    },
    {
      number: "19",
      description: "Deepavali",
    },
    {
      number: "20",
      description: "Skanda Sashti and Kavadi Utsavam",
    },
    {
      number: "21",
      description: "Sri Balaji Pushpa Yagam",
    },
    {
      number: "22",
      description: "Kartika Deepostava Saravalaya Deepam",
    },
    {
      number: "23",
      description: "Gita Jayanti",
    },
  ];

  const AnuualAbhisekhamTable = () => {
    return (
      <>
        {AnnuualAbhisekaItems.length > 0 ? (
          <div>
            <table className={styles.tableContainer}>
              <tbody className={styles.tableBody}>
                {AnnuualAbhisekaItems.map((row) => (
                  <tr key={row.number} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.number}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {row.description}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };
  const AnuualAbhisekhamTableAndServicesTable = () => {
    return (
      <>
        {AnnuualAbhisekaItemsAndServiceProgram.length > 0 ? (
          <div>
            <table className={styles.tableContainer}>
              <tbody className={styles.tableBody}>
                {AnnuualAbhisekaItemsAndServiceProgram.map((row) => (
                  <tr key={row.number} className={styles.tableRow}>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        textAlign: "left",
                      }}
                    >
                      {row.number}
                    </td>
                    <td
                      className={styles.tableDiagonal}
                      style={{
                        fontWeight: 400,
                        color: "#000",
                        textAlign: "left",
                      }}
                    >
                      {row.description}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          ""
        )}
      </>
    );
  };
  return (
    <>
      <div className={styles.PaidSevas}>
        <div className={styles.cardContainer}>
          <Grid>
            <Typography className={styles.typoGraphyHeading}>
              Abhisheka
            </Typography>
          </Grid>
          <Grid sx={{ margin: "20px 0 20px 0" }}>
            <Typography className={styles.Content}>
              An Abhisheka is a ceremony of ablutions and symbolic offerings
              that include milk, honey, ghee, and other items. The ablutions
              symbolize spiritual purification, and each of the offerings
              represents fulfillment on every level. Throughout the abhisheka,
              specific mantras are chanted to invoke blessings that uplift,
              protect and spiritually benefit us.
            </Typography>
            <Grid>
              <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={AbhisekhaItem}
                    columnMapping={columnMapping}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={AbhisekhaItemAnother}
                    columnMapping={columnMapping}
                  />
                </div>
              </div>
            </Grid>
            <div className={styles.tableContainer}>
              <Typography className={styles.Content}>
                Any devotee can take yearly or monthly sponsorship for Abhisheka
                for any deity. For more details see below and/or contact the
                manager.
              </Typography>
            </div>
          </Grid>
          <Grid sx={{ margin: "20px 0 20px 0" }}>
            <Typography className={styles.typoGraphyHeading}>
              Ashtothara Archana
            </Typography>
            <Typography className={styles.Content}>
              Chanting of 108 holy names of the God/Goddess by the priest.
            </Typography>
          </Grid>
          <Grid sx={{ margin: "20px 0 20px 0" }}>
            <Typography className={styles.typoGraphyHeading}>
              Sahasranama Archana
            </Typography>
            <Typography className={styles.Content}>
              Chanting of 1008 holy names of the God/Goddess by the priest.
            </Typography>
          </Grid>
          <Grid sx={{ margin: "20px 0 20px 0" }}>
            <Typography className={styles.typoGraphyHeading}>
              Kalyanotsavam (Balaji, Siva, Subramanya)
            </Typography>
            <Grid sx={{ marginTop: "15px" }}>
              <div className={styles.tableContainer}>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={KalanostavamItems}
                    columnMapping={columnMapping}
                  />
                </div>
                <div className={styles.tableWrapper}>
                  <GridTableComponent
                    tableData={KalanostavamItemsOthers}
                    columnMapping={columnMapping}
                  />
                </div>
              </div>
              <Typography className={styles.Content}>
                Three flower garlands will be supplied on request and payment.
                Advance request is required.
              </Typography>
            </Grid>
          </Grid>
          <Grid sx={{ margin: "20px 0 20px 0" }}>
            <Typography className={styles.typoGraphyHeading}>
              Vahana Sevas
            </Typography>
            <Typography className={styles.Content}>
              Normally when one is seriously ill, the scriptures recommend
              vahana sevas as the gesture of gratitude to the Lord or to get
              quick recovery. The Temple offers these services for the benefit
              of the devotees. When a devotee is going through a very difficult
              period astrologically, he can perform the Vahana Seva.
            </Typography>
            <br />
            <Typography>
              <b>
                Garuda Vahana, Sesha Vahana, Hanumantha Vahana (Sri Rama,
                Venkateswara), Nandi Vahana (Siva).
              </b>
            </Typography>
            <br />
            <Typography>
              <b>Items needed:</b>
            </Typography>
            <Typography className={styles.Content}>
              Three flower garlands for deities and one for Vahana, loose
              flowers, one coconut, fruits, flowers and home cooked prasadas.
              Decorated deities are seated on the Vahana.
              <br />
              <br /> A special sankalpa and puja is performed. The sponsors are
              asked to go around the deities and Vahana as per their desire.
              Mantra Pushpa is chanted - Theertha prasada is given with
              Aseervada. The sponsorship details and flower expenditure details
              can be found from the Manager.
            </Typography>
            <br />
            <Typography>
              <b>
                Tula Bhara and Unjal Sevas also can be arranged at the request
                of the Devotees.
              </b>
            </Typography>
          </Grid>
          <Grid sx={{ marginTop: "15px" }}>
            <Typography className={styles.typoGraphyHeading}>
              Annual Abhishekam Program
            </Typography>
            <div>{AnuualAbhisekhamTable()}</div>
            <br />
            <Typography className={styles.Content}>
              1. Abhisheka for any 9 deities once a week for a period of one
              year $5,001.
            </Typography>
            <br />
            <Typography className={styles.Content}>
              2.Abhisheka for any 5 deities once a week for a period of one year
              $3,001.
            </Typography>
            <br />
            <Typography className={styles.Content}>
              3.Abhisheka for any 1 deity once a week for a period of one year
              $1,116.
            </Typography>
            <br />
            <Typography className={styles.Content}>
              4. Monthly once abhisheka for one deity for a period of one year
              is $301.
            </Typography>
            <br />
          </Grid>
          <Grid sx={{ marginTop: "15px" }}>
            <Typography className={styles.typoGraphyHeading}>
              Annual Abhisheka & Services Program
            </Typography>

            <Typography className={styles.Content}>
              By paying $10,001 any devotee can sponsor for this program. In
              this, apart from of the abhishekas for all the deities, all Temple
              sponsored (celebrated) festivals and Pujas, including all Sevas
              (Muthangi, Poolangi, Tiruppavadai, Vajra Kiireeta) + 1½ at Home ½
              Puja of the devotee choice + one Satyanarayana Puja + One Kalyana
              Utsavam (Balaji/Shiva/Valli) + One Sahasra Nama Archana (for
              Birthday/Wedding Anniversary or any other) for one year.
            </Typography><br />

            <div>{AnuualAbhisekhamTableAndServicesTable()}</div> <br />
            <Typography className={styles.Content}>
              Annual sponsorship for all major religious functions
            </Typography><br />

            <Typography className={styles.Content}>
              By paying $1008, under this program, any devotee can Sponsor for
              all major religious functions :
            </Typography><br />

            <Typography className={styles.Content}>
              In this program in addition to these functions, Balaji Kalyanam
              and one of Shiva or Subramanya Kalyanam are also included. The
              sponsor should take the responsibility to inform the Temple at
              least two weeks before the Kalyana utsavams they choose to
              perform. For more details please contact the Temple manager.
            </Typography>
          </Grid>
        </div>
      </div>
    </>
  );
};
export default PaidSevas;
